import React from 'react';

import { t } from '../../../services/i18nService';

import CaptureDeviceStep from '../capturedevice/CaptureDeviceStep';
import IdCardRectangle from './IdCardRectangle';

import styles from './idcard.scss';

class IdCard extends React.PureComponent {
    render() {
        return (
            <div className={styles.idCard}>
                <h1>{t('idVerification.idCard.title')}</h1>
                <div className={styles.details}>
                    <p>{t('idVerification.idCard.steps')}</p>
                    <ul>
                        <li>{t('idVerification.idCard.room')}</li>
                        <li>{t('idVerification.idCard.document')}</li>
                        <li>{t('idVerification.idCard.position')}</li>
                    </ul>
                </div>
                <CaptureDeviceStep>
                    <IdCardRectangle />
                </CaptureDeviceStep>
            </div>
        );
    }
}

export default IdCard;
